<template>
  <el-container direction="vertical">
    <dl>
      <dt>统计报表</dt>
      <dd v-for="it in list" :key="it.key">
        <el-button :class="['btn', params.date_type === dateTypes[it.key].value ? 'btn_1' : 'btn_2']" @click="dateTypeChoose(it.key)">{{it.name}}</el-button>
      </dd>
    </dl>

    <el-row>
      <el-col :span="4">
        <el-select class="remote-select" filterable v-model="params.org_id" @change="orgIdChange" placeholder="选择客户">
          <el-option
            v-for="item in orgIdList"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          />
        </el-select>
      </el-col>

      <el-col :span="4" v-if="isSystemRole">
        <el-select v-model="params.is_virtual" placeholder="全部设备类别" clearable @change="onSearch()" >
          <el-option
            v-for="item in virtuals"
            :key="item.value"
            :label="item.name"
            :value="item.value" />
        </el-select>
      </el-col>

      <el-col :span="4">
        <el-select class="remote-select" v-model="params.device_id" @change="onSearch" placeholder="选择设备" clearable>
          <el-option
            v-for="item in deviceIdList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>

      <el-col :span="4">
        <el-date-picker
          class="remote-select"
          v-model="params.query_date"
          :value-format="dateFormat"
          :type="dateType"
          :key="dateType"
          :editable="false"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="onSearch">
        </el-date-picker>
      </el-col>

      <el-col :span="5" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
        <el-button v-permission="'导出扫描仪日报月报和年报'" icon="el-icon-upload2" class="btn btn_3" @click="onExport">导出</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(0, 246)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="params.page_num"
      @current-change="onPageChange"
      :page-size="params.page_size"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import Util from '@/api/util'
import { getLoginUserInfo } from '@/api/permission'

export default {
  data () {
    const date = new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
    return {
      dateType: 'month',
      dateFormat: 'yyyy-MM',
      dateTypes: BasicDataHelper.DateTypes,
      virtuals: BasicDataHelper.virtuals,
      isSystemRole: getLoginUserInfo().isSystemRole,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      params: {
        is_virtual: null,
        org_id: '',
        device_id: '',
        date_type: 4,
        query_date: date,
        device_type: 1,
        page_num: 1,
        page_size: 10
      },
      deviceIdList: [],
      orgIdList: [],
      pageData: {
        total: 0,
        items: []
      },
      share: {},
      tableColList: [
        {
          key: 'owner_org_name',
          name: '客户名称'
        },
        {
          key: 'device_name',
          name: '设备名称'
        },
        {
          key: 'total',
          name: '扫描切片数量'
        }
      ],
      list: [
        {
          key: 'DATE',
          name: '日报'
        },
        {
          key: 'MONTH',
          name: '月报'
        },
        {
          key: 'YEAR',
          name: '年报'
        }
      ]
    }
  },
  created () {
    this.initData()
    this.getDeviceIdList()
    this.getOrgIdList()
  },
  methods: {
    getDeviceIdList () {
      Backend.post(this, 'statistics/get_device_by_org', { org_id: this.params.org_id, device_type: 1 }).then(data => {
        this.deviceIdList = data.devices.map(it => {
          return {
            value: it.device_id,
            label: it.device_name
          }
        })
      })
    },
    getOrgIdList () {
      Backend.filterKeyValueList(this, ['org', 'org_customer']).then(data => {
        this.orgIdList = [{
          value: '',
          text: '所有客户'
        }, ...data]
      })
    },
    orgIdChange () {
      this.params.device_id = ''
      this.getDeviceIdList()
      this.onSearch()
    },
    initData () {
      Backend.post(this, 'statistics/work_statistics', { ...this.params, export: false }).then(data => {
        this.pageData.total = data.count
        this.pageData.items = data.items
      })
    },
    onSearch () {
      this.initData()
    },
    onPageChange (v) {
      this.params.page_num = v
      this.initData()
    },
    onPageSizeChange (v) {
      this.params.page_size = v
      this.initData()
    },
    onExport () {
      this.$confirm('确定要导出?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        Backend.post(this, 'statistics/work_statistics', { ...this.params, export: true }).then(res => {
          if (res.count && res.count > 0) {
            Util.downLoadFile(res.export_url)
          } else {
            this.$message.warning('暂无数据导出!')
          }
        })
      }).catch()
    },
    dateTypeChoose (key) {
      if (this.params.date_type === this.dateTypes[key].value) return
      this.params.date_type = this.dateTypes[key].value
      this.dateType = key.toLowerCase()
      this.dateFormat = key === 'YEAR' ? 'yyyy' : key === 'MONTH' ? 'yyyy-MM' : 'yyyy-MM-dd'
      this.params.query_date = this.getCurrentDate(key)
      this.initData()
    },
    getCurrentDate (type) {
      const date = new Date()
      const y = date.getFullYear()
      const m = date.getMonth() + 1
      const d = date.getDate()
      return type === 'YEAR' ? y + '' : type === 'MONTH' ? y + '-' + m : y + '-' + m + '-' + d
    }
  }
}
</script>

<style lang="scss" scoped>
  dl{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E5E5E5;
    padding-bottom: 16px;
    margin-bottom: 10px;
    dt,dd{
      float: left;
    }
    dt{
      margin-right: 10px;
    }
    dd{
      margin: 0 2px;
    }
  }
</style>
